import Animation from "@/Shared/Animations/Animation";
import { AnimationsInlineIconNudge } from "./CustomComponents/AnimationsInlineIconNudge";

const RedExclamationAnimatedIcon: React.FC = () => {
  return (
    <AnimationsInlineIconNudge nudge="exclamation">
      <Animation
        width={25}
        height={25}
        lottieFilesUrl="https://edit.lottiefiles.com/?src=https%3A%2F%2Fassets4.lottiefiles.com%2Fpackages%2Flf20_HYlQBb.json"
        pathToAnimation="/animations/red-exclamation.json"
      />
    </AnimationsInlineIconNudge>
  );
};
export default RedExclamationAnimatedIcon;
